const PRODUCTS = {

  /* ================= ROUND NECK ================= */

  "cotton-round-neck-t-shirt": {
    category: "round-neck",

    title: "Premium 180 gsm Biowash Regular Fit Cotton Round Neck T Shirts",

    tag: "Biowash",
    images: [
      "/tshirts/rnw0.png",
      "/tshirts/rnw1.png",
      "/tshirts/rnw2.png",
      "/tshirts/rnw3.png",
      "/tshirts/rnw4.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#E5E5E5","#A8A8A8","#000000","#F3EDE5","#A9D3E9","#E6B89C",
      "#F4C430","#B11226","#1F2A44"
    ],
  },

  "oversized-round-neck-t-shirt": {
    category: "round-neck",
    title: "240GSM French Terry Cotton Biowash Oversized Round Neck t-shirt",
    tag: "Oversized Fit",
    images: [
      "/tshirts/ob0.png",
      "/tshirts/ob1.png",
      "/tshirts/ob2.png",
      "/tshirts/ob3.png",
      "/tshirts/ob4.png",
      "/tshirts/ob5.png",
      "/tshirts/ob6.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#F2F2F2","#B5B5B5","#000000","#3F3F3F","#98A832","#9BB67C",
      "#B88ED8","#1F2238","#2E3B8E","#1C7899","#8C1D2C",
      "#B11226","#C58F2C","#8B5E3C"
    ],
  },

  "dryfit-round-neck-t-shirt": {
    category: "round-neck",
    title: "Premium 170 gsm Dryfit Roundneck T-shirt",
    tag: "Dryfit Fabric",
    images: [
      "/tshirts/rnb0.png",
      "/tshirts/rnb1.png",
      "/tshirts/rnb2.png",
      "/tshirts/rnb3.png",
      "/tshirts/rnb4.png",
      "/tshirts/rnb5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#000000","#5F6A72","#A9A9A9","#F2F2F2","#7FA7D9",
      "#4A73C9","#2F4BB2","#7B1E2B","#D81B60","#E1061B",
      "#FF5A00","#F4B400","#A8E04A"
    ],
  },

  /* ================= POLOS ================= */

  "micropolyester-collar-t-shirt": {
    category: "polo",
    title: "Premium 220 gsm Micropolyester Premium Collar T Shirt regular fit",
    tag: "Micropolyester",
    images: [
      "/polo/pbl0.png","/polo/pbl1.png","/polo/pbl2.png",
      "/polo/pbl3.png","/polo/pbl4.png","/polo/pbl5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#000000","#5F5F63","#D9D9D9","#E0CC73","#C49A45","#4F463F",
      "#2F4F45","#BFE0DD","#8EC5D6","#3E98A5","#5A8FC2",
      "#2E3F75","#2B4B63","#26264F","#6D1A1A"
    ],
  },

  "micropolyester-collar-t-shirt-press-buttons": {
    category: "polo",
    title: "Premium 220 gsm Micropolyester Premium Collar T Shirt regular fit With Press Buttons",
    tag: "Press Buttons",
    images: [
      "/polo/wc0.png","/polo/wc1.png","/polo/wc2.png",
      "/polo/wc3.png","/polo/wc4.png","/polo/wc5.png","/polo/wc6.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#000000","#2F3E5C","#8C8C8C","#3B3BA3","#5E8DBE",
      "#2E88A8","#A9D3D3","#2B2F4F","#4A443A","#C49433","#B60D14"
    ],
  },

  "cotton-collar-t-shirt": {
    category: "polo",
    title: "Premium 260 gsm Cotton Collar T-shirt Solid (Polo)",
    tag: "Cotton Polo",
    images: [
      "/polo/pg0.png","/polo/pg1.png","/polo/pg2.png",
      "/polo/pg3.png","/polo/pg4.png","/polo/pg5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors:[ // Row 1
  "#000000", // Black
  "#7D7D7D", // Medium Grey
  "#E5E5E5", // Light Grey
  "#2B2B2B", // Textured Dark (approx)
  "#D9D9D9", // Light Heather
  "#E8D8B8", // Cream Beige
  "#A89A78", // Sand

  // Row 2
  "#0B3D0B", // Dark Green
  "#5E6726", // Olive
  "#7A9B3F", // Moss Green
  "#0F7F3F", // Green
  "#0F4F4F", // Teal Dark
  "#0E7568", // Teal
  "#56B4A3", // Mint Teal

  // Row 3
  "#14255D", // Navy
  "#2D2A83", // Indigo
  "#3E3B9E", // Royal Blue
  "#135CA7", // Blue
  "#1F76B4", // Ocean Blue
  "#3E6DB3", // Soft Blue
  "#517AC0", // Denim Blue

  // Row 4
  "#3B0B5F", // Deep Purple
  "#061B4D", // Midnight Blue
  "#12325F", // Dark Blue
  "#6A8DB5", // Light Denim
  "#2EA8B8", // Cyan
  "#F0E318", // Bright Yellow
  "#F28C28"  // Orange
]
  },

  "cotton-collar-t-shirt-with-tipping": {
    category: "polo",
    title: "Premium 260 gsm Cotton Collar T-shirt Solid (Polo) With Tipping",
    tag: "With Tipping",
    images: [
      "/polo/pc0.png","/polo/pc1.png","/polo/pc2.png",
      "/polo/pc3.png","/polo/pc4.png","/polo/pc5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [// Row 1
  "#000000", // Black
  "#0A0A0A",
  "#111827", // Very Dark Blue
  "#6B7280", // Grey
  "#A8A29E", // Warm Grey
  "#D6D3D1", // Light Grey
  "#F3F4F6", // Off White

  // Row 2
  "#8EC6E8", // Sky Blue
  "#3B82F6", // Blue
  "#60A5FA", // Light Blue
  "#1E3A8A", // Navy
  "#6B21A8", // Purple
  "#E5E7EB", // Light Neutral

  // Row 3
  "#374151", // Dark Slate
  "#4B5563",
  "#111827",
  "#4B5563",
  "#6B4F1D", // Brown
  "#A16207", // Dark Mustard
  "#FDE68A", // Sand Yellow
  "#A3E635", // Lime

  // Row 4
  "#DC2626", // Red
  "#EF4444", // Light Red
  "#000000",
  "#B91C1C", // Deep Red Stripe look
  "#0F172A",
  "#1F2937",
  "#6B7280",
  "#9CA3AF",
  "#E5E7EB",

  // Row 2
  "#1E40AF",
  "#F87171",
  "#2563EB",
  "#DC2626",
  "#EA580C",
  "#FB923C",

  // Row 3
  "#0F172A",
  "#0C4A6E",
  "#64748B",
  "#1D4ED8",
  "#60A5FA",
  "#06B6D4",
  "#4338CA",

  // Row 4
  "#312E81",
  "#1E3A8A",
  "#052E16",
  "#365314",
  "#6B8E23",
  "#D9F99D"
    ]
  },

  "dryfit-collar-t-shirt": {
    category: "polo",
    title: "Premium 200 gsm Drifit Collar t-Shirt Solid (Sports Polo)",
    tag: "Dryfit Polo",
    images: [
      "/polo/oc0.png","/polo/oc2.png",
      "/polo/oc3.png","/polo/oc4.png","/polo/oc5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: ["#000000", // Black
  "#374151", // Dark Slate Blue Grey
  "#7C7C7C", // Medium Grey
  "#E5E5E5", // Light Grey
  "#1E2A55", // Navy
  "#1F49B6", // Royal Blue
  "#4A7ECF", // Soft Blue

  // Row 2
  "#5A1027", // Deep Maroon
  "#E1062C", // Red
  "#F5821F", // Orange
  "#E6B21A"  // Mustard Yellow
  
  ]
  },

  "dryfit-collar-t-shirt-with-tipping": {
    category: "polo",
    title: "Premium 200 gsm Drifit Collar t-Shirt Solid (Sports Polo) With Tipping",
    tag: "Dryfit + Tipping",
    images: [
      "/polo/bt0.png","/polo/bt1.png","/polo/bt2.png",
      "/polo/bt3.png","/polo/bt4.png","/polo/bt5.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [/// Top Row
  "#000000", // Black
  "#334155", // Dark Blue Grey
  "#A3AFBF", // Cool Light Grey
  "#E7E5E4", // Off White
  "#4A7ECF", // Denim Blue
  "#142850", // Deep Navy
  "#4C1026", // Dark Maroon

  // Middle Highlight
  "#E1062C", // Bright Red

  // Third Row
  "#111111", // Rich Black
  "#374151", // Slate
  "#F8FAFC", // Almost White
  "#0F172A", // Midnight Blue
  "#1E40AF", // Royal Blue
  "#0E7490", // Teal Blue
  "#1D4ED8", // Strong Blue
  "#3F8FCB", // Soft Sky Blue

  // Bottom Row
  "#5A1027", // Deep Wine
  "#C9252D", // Dark Red
  "#F2C94C"  // Mustard Yellow
  // 
  ]
  },

  "inside-out-collar-t-shirt": {
    category: "polo",
    title: "Premium 230 gsm Inside Out Collar T-Shirt Solid (Polo)",
    tag: "Inside Out Design",
    images: [
      "/polo/mc0.png","/polo/mc1.png","/polo/mc2.png",
      "/polo/mc3.png","/polo/mc4.png","/polo/mc5.png","/polo/mc6.png",
    ],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: ["#EDEDED","#BFC7CF","#000000","#2E3F7F","#2847B8","#4A1F2D"],
  },

  /* ================= HOODIES ================= */

  "pullover-hoodies": {
    category: "hoodie",
    title: "Pullover Hoodie Cotton fleece 300gsm with kangaroo pockets Biowash",
    tag: "Pullover",
    images: ["/hoodies/hp0.png","/hoodies/hp1.png","/hoodies/hp2.png","/hoodies/hp3.png","/hoodies/hp4.png","/hoodies/hp5.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [// Row 1
  "#000000", // Black
  "#5B5B5B", // Dark Grey
  "#7A7A7A", // Medium Grey
  "#A8A6A6", // Light Grey
  "#E6E6E6", // Off White
  "#4F7F63", // Forest Green
  "#6B7046", // Olive Green

  // Row 2
  "#8E0E1B", // Deep Red
  "#C4161C", // Red
  "#E0645C", // Coral
  "#DFA1A5", // Soft Pink
  "#D79BB5", // Pink Mauve
  "#51B091", // Teal Green
  "#9EAE63", // Light Olive

  // Row 3
  "#4B2A33", // Plum Brown
  "#5E4841", // Brown
  "#E78512", // Orange
  "#E5AC1A", // Mustard
  "#8E3AA8", // Purple
  "#8F7AC6", // Lavender
  "#1F3566", // Navy

  // Row 4
  "#3A4F8D", // Steel Blue
  "#5FA7C8"  // Sky Blue
  ]
  },

  "zipper-hoodie": {
    category: "hoodie",
    title: "Zipper Hoodie Cotton Fleece 300 gsm Biowash",
    tag: "Zipper Style",
    images: ["/hoodies/hm0.png","/hoodies/hm1.png","/hoodies/hm2.png","/hoodies/hm3.png","/hoodies/hm4.png","/hoodies/hm5.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [// Row 1
  "#000000", // Black
  "#5A5A5A", // Dark Grey
  "#7D7D7D", // Medium Grey
  "#AFAFAF", // Light Grey
  "#E8E8E8", // Off White
  "#4E7F63", // Forest Green
  "#717746", // Olive

  // Row 2
  "#9B1B2B", // Deep Red
  "#C71F25", // Red
  "#E25B52", // Coral
  "#DFA0A2", // Soft Pink
  "#D79CB6", // Blush Pink
  "#4FB192", // Teal
  "#9FAE63", // Light Olive

  // Row 3
  "#4A2932", // Plum Brown
  "#5C4841", // Brown
  "#E07F11", // Orange
  "#E5AC1D", // Mustard
  "#9039AA", // Purple
  "#8B78C7", // Lavender
  "#243865", // Navy

  // Row 4
  "#3B4F8F", // Steel Blue
  "#5DA7C9"  // Sky Blue
  ],
  },

  "premium-pullover-hoodie": {
    category: "hoodie",
    title: "Premium Pullover Hoodie Cotton fleece 350gsm with kangaroo pockets Biowash",
    tag: "Premium",
    images: ["/hoodies/hb0.png","/hoodies/hb1.png","/hoodies/hb2.png","/hoodies/hb3.png","/hoodies/hb4.png","/hoodies/hb5.png","/hoodies/hb6.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#000000", // Black
  "#5C5E61", // Dark Grey
  "#86898C", // Medium Grey
  "#B3B0B1", // Light Grey
  "#ECEBEB", // Off White
  "#4C7D61", // Forest Green
  "#7A7F4E", // Olive Green

  
  "#9A1427", // Deep Red
  "#C6141E", // Bright Red
  "#E35B53", // Coral
  "#DFA1A3", // Soft Pink
  "#D998B8", // Blush
  "#4FB091", // Teal Green
  "#9EAD63", // Light Olive

  // Row 3
  "#4A2830", // Wine
  "#5B4741", // Brown
  "#E38112", // Orange
  "#E6AE1B", // Mustard Yellow
  "#8E39A9", // Purple
  "#8C78C8", // Lavender
  "#24376A", // Navy

  // Row 4
  "#3B4E8E", // Steel Blue
  "#5FA7C9"  // Sky Blue
    ],
  },

  "premium-support-hoodie": {
    category: "hoodie",
    title: "Premium Zipper Hoodie Cotton Fleece 350 gsm Biowash",
    tag: "Premium Support",
    images: ["/hoodies/hdb0.png","/hoodies/hdb1.png","/hoodies/hdb2.png","/hoodies/hdb3.png","/hoodies/hdb4.png","/hoodies/hdb5.png","/hoodies/hdb6.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
  // Row 1
  "#000000", // Black
  "#5C5D60", // Dark Grey
  "#87898B", // Medium Grey
  "#B1AFB0", // Light Grey
  "#EFEDED", // Off White
  "#4F7D62", // Forest Green
  "#787C4C", // Olive

  // Row 2
  "#9C1427", // Deep Red
  "#C6151F", // Red
  "#E05D52", // Coral
  "#DFA2A4", // Soft Pink
  "#D89AB7", // Blush
  "#4EB191", // Teal
  "#9EAD64", // Light Olive

  // Row 3
  "#4B2730", // Wine
  "#5A4742", // Brown
  "#E38113", // Orange
  "#E7AF1C", // Mustard
  "#8F3AA9", // Purple
  "#8E79C8", // Lavender
  "#25386A", // Navy

  // Row 4
  "#3C4F8F", // Steel Blue
  "#60A8C9"  // Sky Blue

    ],
  },

  "sweatshirt": {
    category: "hoodie",
    title: "Premium Sweatshirt Cotton fleece 350gsm Biowash",
    tag: "Classic Sweatshirt",
    images: ["/hoodies/sbr0.png","/hoodies/sbr1.png","/hoodies/sbr2.png","/hoodies/sbr3.png","/hoodies/sbr4.png","/hoodies/sbr5.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      // Row 1
  "#000000", // Black
  "#5A5C60", // Dark Grey
  "#818386", // Medium Grey
  "#AFAFB1", // Soft Grey
  "#EDECEC", // Off White
  "#4F7C62", // Forest Green
  "#7A7E4D", // Olive Green

  // Row 2
  "#971727", // Deep Red
  "#C31823", // Red
  "#E05E55", // Coral
  "#DFA2A6", // Light Pink
  "#D89AB9", // Blush Pink
  "#4CAF90", // Teal Green
  "#9EAF66", // Light Olive

  // Row 3
  "#4B2731", // Wine
  "#5D4A45", // Brown
  "#E37F11", // Orange
  "#E7B01F", // Mustard
  "#8C39A8", // Purple
  "#907BC9", // Lavender
  "#24386D", // Navy

  // Row 4
  "#3C4F94", // Steel Blue
  "#62A9CC"  // Sky Blue
    ],
  },

  /* ================= JACKETS ================= */

  "varsity-jacket": {
    category: "jacket",
    title: "Premium Varsity Jacket Cotton fleece 400gsm Biowash",
    tag: "Varsity Jacket",
    images: ["/jackets/vb0.png","/jackets/vb1.png","/jackets/vb2.png","/jackets/vb3.png","/jackets/vb4.png","/jackets/vb5.png","/jackets/vb6.png"],
    sizes: ["S","M","L","XL","2XL","3XL"],
    colors: [
      "#000000", // Black
  "#5E6063", // Dark Grey
  "#7F8184", // Medium Grey
  "#A9A9AB", // Light Grey
  "#ECEBEB", // Off White
  "#4E7A60", // Forest Green
  "#7C8153", // Olive Green


  "#981726", // Deep Red
  "#C41722", // Red
  "#E15B52", // Coral Red
  "#E09FA3", // Soft Pink
  "#D89BB8", // Blush Pink
  "#4FB091", // Teal Green
  "#A1B063", // Light Olive

 
  "#4C2831", // Wine
  "#5C4943", // Brown
  "#E37C10", // Orange
  "#E8AE1F", // Mustard Yellow
  "#8C3AA7", // Purple
  "#917CCB", // Lavender
  "#25386C", // Navy Blue

 
  "#3D5196", // Royal Blue
  "#66ACCF"  // Sky Blue
    ],
  },

  /* ================= ACCESSORIES ================= */

  "tote-bag": {
    category: "accessories",
    title: "Premium Tote Bag Cotton 350 gms",
    tag: "Carry Style",
    images: ["/hoodies/bag0.png","/hoodies/bag1.png","/hoodies/bag2.png","/hoodies/bag3.png","/hoodies/bag4.png","/hoodies/bag5.png"],
    sizes: ["Standard"],
    colors: ["#000000","#444444","#bbbbbb"],
  },

  "caps": {
    category: "accessories",
    title: "Premium Caps",
    tag: "Snapback",
    images: ["/hoodies/snapBack0.png","/hoodies/snapBack1.png","/hoodies/snapBack2.png","/hoodies/snapBack3.png","/hoodies/snapBack4.png"],
    sizes: ["Standard"],
    colors: ["#000000","#444444","#bbbbbb"],
  },

};

export default PRODUCTS;
